<div class="h-100-vh public-container" fxLayout="column" fxLayoutAlign="center center">
  <router-outlet></router-outlet>
</div>